module.exports = "174d0cbb2e0631febe56f8a6477ae3cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-select.png
// module id = 41
// module chunks = 0